import { useGetIdentity, useStore } from "react-admin";

import { ALL_STANDORT_VALUE, STORE_KEYS, type StoredStandort } from "../constants";
import { UserType } from "../generated/graphql";
import { useOrganizationContext } from "./useOrganizationContext";

/**
 * Hook to get the current location filter context.
 *
 * Returns the selected standort (top-level location) ID from store.
 * Designed to be extensible for future hierarchy levels (e.g., bereich).
 *
 * @returns Object with locationId (currently standort ID)
 */
export const useLocationFilterContext = (): { locationId: string | null } => {
  const { data: identity } = useGetIdentity();
  const { organizationId } = useOrganizationContext();
  const [storedStandort] = useStore<StoredStandort>(STORE_KEYS.SELECTED_STANDORT_ID, ALL_STANDORT_VALUE);

  if (identity?.kind === UserType.CustomerService) {
    return { locationId: null };
  }

  if (typeof storedStandort === "object" && organizationId && storedStandort.organizationId !== organizationId) {
    return { locationId: null };
  }
  const selectedStandortId = typeof storedStandort === "object" ? storedStandort.id : storedStandort;

  return { locationId: selectedStandortId === ALL_STANDORT_VALUE ? null : selectedStandortId };
};
